import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Card, Button, Form, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TblHInegreso, headTbl } from '../../data/tables';
import { useGetDta } from '../../hooks/useGetDta';
import { useForm } from '../../hooks/useForm';
import moment from 'moment';
import LoadinSpin from '../ui/LoadinSpin';
import { useShowColums, useShowColumsHook } from '../../hooks/useShowColums';
import DropDownsCol from '../ui/DropDownsCol';
import Table from '../Table';
import classNames from 'classnames';
import ModIngreso from './ModIngreso';
import Confirmation from '../ui/Confirmation';
import { fetchConToken } from '../../api/fetch';
import { useContextInfo } from '../../context/ContextInfo';
import CardIngresos from './CardIngresos';
import { AuthContext } from '../../auth/AuthContext';
import { getInitialColumns } from '../../data/cards';
const baseUrl = process.env.REACT_APP_API;

const TblIngresos = ({ allows }) => {
    const { ie_all, ie_agregar, ie_editar, ie_eliminar } = allows;
    const { setResp } = useContextInfo();
    const { auth } = useContext(AuthContext);
    const [rs, setRs] = useState(false);

    const initialColums = getInitialColumns('ingresosall', TblHInegreso);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'ingresosall');
    let day = moment().startOf('month').format('YYYY-MM-DD');
    let day2 = moment().endOf('month').format('YYYY-MM-DD');
    const [show, setShow] = useState(false);
    const [item, setItem] = useState({});
    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});
    const [values, handleInputChange, setFormValue] = useForm({
        fechas: day,
        fechae: day2,
        agente: auth.uid,
        todos: ie_all,
    });
    const { loading, data, getInfo } = useGetDta(`plus/ingresosall`, { ...values }, 'PUT');

    useEffect(() => {
        getItems();
    }, [values]);
    const getItems = () => {
        getInfo(`plus/ingresosall`, { ...values }, 'PUT');
    };

    const dele = (id) => {
        setInfo({ id, type: 'INGRESO' });
        setShowd(true);
    };
    const openEdit = (ol) => {
        setItem(ol);
        setShow(true);
    };
    if (loading) return <LoadinSpin />;
    const TipoColumn = ({ row }) => {
        return (
            <>
                <span className="text-center">${row.original.monto}</span>
            </>
        );
    };
    const StatusColumn = ({ row }) => {
        return (
            <>
                <span
                    className={classNames('badge bg-success', {
                        'bg-success': row.original.tipo === 'INGRESO',
                        'bg-danger': row.original.tipo === 'EGRESO',
                    })}>
                    {row.original.tipo}
                </span>
            </>
        );
    };
    const ActionColumn = ({ row }) => {
        return (
            <>
                {row.original.tipo_registro === 'inegreso' && (
                    <>
                        {' '}
                        {ie_editar && (
                            <OverlayTrigger
                                className="action-icon "
                                placement="left"
                                overlay={<Tooltip id="overlay-example"> Editar</Tooltip>}>
                                <i className="mdi mdi-pencil mdi-18px " onClick={() => openEdit(row.original)}></i>
                            </OverlayTrigger>
                        )}
                        {ie_eliminar && (
                            <>
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="overlay-example"> Borrar </Tooltip>}>
                                    <i className="mdi mdi-delete mdi-18px " onClick={() => dele(row.original.id)}></i>
                                </OverlayTrigger>
                            </>
                        )}
                    </>
                )}
            </>
        );
    };
    const columns = [
        {
            Header: 'Referencia',
            accessor: 'ref',
            sort: true,
        },
        {
            Header: 'Fecha',
            accessor: 'fecha',
            sort: true,
        },
        {
            Header: 'Monto',
            accessor: 'monto',
            sort: true,
            Cell: TipoColumn,
        },
        {
            Header: 'Tipo',
            accessor: 'tipo',
            sort: true,
            Cell: StatusColumn,
        },
        {
            Header: 'Agente',
            accessor: 'name',
            sort: true,
        },

        {
            Header: 'Descripción',
            accessor: 'descri',
            sort: true,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const getPdf = async () => {
        setRs(true);
        const r = await fetchConToken(`plus/ingresosxsl`, { ...values }, 'PUT');
        if (r.ok) {
            const url = `${baseUrl}tem/ingresos-egresos.xlsx`; // Ruta al archivo que deseas descargar
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = 'ingresos-egresos.xlsx'; // Nombre que tendrá el archivo al descargar
            anchor.click();
        } else {
            setResp(r);
        }
        setRs(false);
    };
    const sizePerPageList = headTbl(data);
    const handleSearchValue = (searchValue) => {
        setFormValue({ ...values, find: searchValue });
    };
    return (
        <div>
            {' '}
            <Row>
                <Col xs={12}>
                    <CardIngresos data={data} />
                    <Card>
                        <Card.Body>
                            {' '}
                            <Table
                                columns={columns}
                                data={data}
                                pageSize={25}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                columnasVisibles={columnasVisibles}
                                isSearchable={true}
                                handleSearchValue={handleSearchValue}
                                theadClass="table-light"
                                searchBoxClass="mb-2"
                                customButton={
                                    ie_agregar && (
                                        <Button type="button" onClick={() => openEdit({})}>
                                            <b>+</b> Nuevo
                                        </Button>
                                    )
                                }
                                visiblesCustum={
                                    <div className="d-flex">
                                        {' '}
                                        <DropDownsCol
                                            cols={columnasVisibles} // Pasar el estado desde TblZonas
                                            toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                                        />
                                        <div className="mx-3">
                                            {rs ? (
                                                <Button variant="primary" disabled>
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    Generando archivo ...
                                                </Button>
                                            ) : (
                                                <Button variant="secondary" onClick={getPdf}>
                                                    Excel
                                                </Button>
                                            )}
                                        </div>
                                        <Form.Group
                                            className="mb-3 d-flex align-items-center ml-2"
                                            controlId="validationCustofs">
                                            <Form.Label>Fechas</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="fechas"
                                                value={values.fechas}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>{' '}
                                        <Form.Group
                                            className="mb-3 d-flex align-items-center"
                                            controlId="validationCustofe">
                                            <Form.Label>al</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="fechae"
                                                value={values.fechae}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>{' '}
                                    </div>
                                }
                            />
                        </Card.Body>
                    </Card>
                    <ModIngreso show={show} callBk={getInfo} onClose={() => setShow(false)} item={item} />
                    <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
                </Col>
            </Row>
        </div>
    );
};

export default TblIngresos;
